export default __webpack_public_path__ + "static/media/item1.b74e2e14.png";